"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var VocabSentencesWrapper = function VocabSentencesWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showSentenceSubmissionForm", _descriptor, _this);
      _initializerDefineProperty(_this, "popupSentence", _descriptor2, _this);
      _initializerDefineProperty(_this, "limit", _descriptor3, _this);
      _initializerDefineProperty(_this, "showPaginator", _descriptor4, _this);
      _this.afterGetSentences = function (resp) {
        var skipSetIndexData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!skipSetIndexData) {
          if (_this.props.wordId) {
            _this.wordSentenceStore.setIndexData(resp);
          } else if (_this.props.conceptId) {
            _state.DeckUI.conceptSentenceStore.setIndexData(resp);
          }
        }
        _this.setPaginator();
        if ((0, _utils.isPresent)(_this.props.popupSentenceId)) {
          _this.popupSentence = _this.wordSentenceStore.indexData.find(function (item) {
            return item.id === _this.props.popupSentenceId;
          });
        }
      };
      _this.onToggleShowSentenceSubmissionForm = function () {
        _this.showSentenceSubmissionForm = !_this.showSentenceSubmissionForm;
      };
      _this.onClickSentence = function (sentence) {
        _this.popupSentence = sentence;
      };
      _this.onToggleCreateReview = function (id, wordReview) {
        if (!_state.AppUI.user.isMember && !_state.AppUI.layout.isNative) {
          _state.AppUI.routeStore.routeToNamed('memberships.index');
          return;
        }
        var reviewCard = _this.reviewCard(id);
        if (reviewCard) {
          _state.AppUI.cardStore.destroy({
            ids: {
              cardId: reviewCard.id
            }
          }, _this.getReviews);
        } else {
          _state.AppUI.cardStore.create({
            data: {
              card_type_slug: 'translate',
              user_id: _state.AppUI.user.id,
              word_id: wordReview ? id : null,
              sentence_id: wordReview ? null : id,
              language_id: _state.AppUI.targetLanguageId
            }
          }, _this.getReviews);
        }
      };
      _this.hasReview = function (id) {
        return (0, _utils.isPresent)(_this.reviewCard(id));
      };
      _this.reviewCard = function (id) {
        return _state.AppUI.cardStore.indexData.find(function (item) {
          return item.word && item.word.id === id || item.sentence && item.sentence.id === id;
        });
      };
      _this.getReviews = function () {
        // AppUI.cardStore.getIndex({queryStrings: {sentences_for_word: true}, filters: {user_id: AppUI.user.id, word_id: this.props.wordId}});
      };
      _this.setPaginator = function () {
        var _this$sentences, _this$store;
        if (((_this$sentences = _this.sentences) === null || _this$sentences === void 0 ? void 0 : _this$sentences.length) === _this.limit || ((_this$store = _this.store) === null || _this$store === void 0 ? void 0 : _this$store.page) > 1) {
          _this.showPaginator = true;
        }
      };
      _this.getSentences = function () {
        if (_this.props.wordId) {
          _this.wordSentenceStore.loadForWord(_this.props.wordId, _this.afterGetSentences);
        }
        if (_this.props.conceptId) {
          var _DeckUI$conceptSenten;
          if (!_state.DeckUI.conceptSentenceStore.hasIndexData || ((_DeckUI$conceptSenten = _state.DeckUI.conceptSentenceStore.ids) === null || _DeckUI$conceptSenten === void 0 ? void 0 : _DeckUI$conceptSenten.conceptId) !== _this.props.conceptId) {
            _state.DeckUI.conceptSentenceStore.clearIndexData();
            _state.DeckUI.conceptSentenceStore.getIndex({
              sort: 'level_abbreviation, -created_at',
              limit: _this.limit,
              ids: {
                conceptId: _this.props.conceptId
              }
            }, _this.afterGetSentences);
          } else {
            _this.setPaginator();
          }
        }
        _this.getReviews();
      };
      if (props.wordId) {
        _this.limit = 10;
      } else if (props.conceptId) {
        _this.limit = 6;
      }
      _this.getSentences();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.wordId !== this.props.wordId) {
          this.getSentences();
        } else if (prevProps.conceptId !== this.props.conceptId) {
          this.getSentences();
        }
      }
    }, {
      key: "sentencesHaveVideo",
      get: function get() {
        return (0, _lodash.every)(this.wordSentenceStore.indexData.map(function (sentence) {
          var _sentence$target;
          return (_sentence$target = sentence.target) === null || _sentence$target === void 0 ? void 0 : _sentence$target.hasVideoClip;
        }));
      }
    }, {
      key: "isWaitingForSentences",
      get: function get() {
        var _this$store2;
        return ((_this$store2 = this.store) === null || _this$store2 === void 0 ? void 0 : _this$store2.hasOutstandingRequests) || this.store && !this.store.initialRequestReceived || this.props.hideWhenBlank || this.props.showSpinner;
      }
    }, {
      key: "showLoadingSpinner",
      get: function get() {
        var _this$store3;
        return this.props.showSpinner || !(0, _utils.isPresent)(this.sentences) && (((_this$store3 = this.store) === null || _this$store3 === void 0 ? void 0 : _this$store3.hasOutstandingRequests) || this.store && !this.store.initialRequestReceived);
      }
    }, {
      key: "shouldHideSentences",
      get: function get() {
        return !(0, _utils.isPresent)(this.sentences) && this.isWaitingForSentences;
      }
    }, {
      key: "shouldShowBlankState",
      get: function get() {
        var _this$props$word;
        return !(0, _utils.isPresent)(this.sentences) && !this.isWaitingForSentences && (0, _utils.isBlank)((_this$props$word = this.props.word) === null || _this$props$word === void 0 ? void 0 : _this$props$word.vocabTriadConceptId);
      }
    }, {
      key: "sentences",
      get: function get() {
        if (this.props.wordId) {
          return this.wordSentenceStore.indexData;
        }
        if (this.props.conceptId) {
          return _state.DeckUI.conceptSentenceStore.indexData;
        }
      }
    }, {
      key: "wordSentenceStore",
      get: function get() {
        return this.props.wordSentenceStore || _state.AppUI.wordSentenceStore;
      }
    }, {
      key: "store",
      get: function get() {
        if (this.props.wordId) {
          return this.wordSentenceStore;
        }
        if (this.props.conceptId) {
          return _state.DeckUI.conceptSentenceStore;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sentences: this.sentences,
          store: this.store,
          showSentenceSubmissionForm: this.showSentenceSubmissionForm,
          onToggleShowSentenceSubmissionForm: this.onToggleShowSentenceSubmissionForm,
          popupSentence: this.popupSentence,
          onClickSentence: this.onClickSentence,
          onToggleCreateReview: this.onToggleCreateReview,
          hasReview: this.hasReview,
          sentencesHaveVideo: this.sentencesHaveVideo,
          showLoadingSpinner: this.showLoadingSpinner,
          shouldHideSentences: this.shouldHideSentences,
          shouldShowBlankState: this.shouldShowBlankState,
          limit: this.limit,
          showPaginator: this.showPaginator
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSentenceSubmissionForm", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "popupSentence", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "limit", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showPaginator", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "sentencesHaveVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentencesHaveVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isWaitingForSentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isWaitingForSentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showLoadingSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showLoadingSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldHideSentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldHideSentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shouldShowBlankState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldShowBlankState"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordSentenceStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordSentenceStore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "store", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "store"), _class2.prototype), _class2)) || _class;
};
VocabSentencesWrapper.displayName = 'VocabSentencesWrapper';
var _default = exports["default"] = VocabSentencesWrapper;